import { render } from "./DeveloperItem.vue?vue&type=template&id=34f998ae"
import script from "./DeveloperItem.vue?vue&type=script&lang=js"
export * from "./DeveloperItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__